
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	@Component({
		name: 'sbgl'
	})
	export default class sbgl extends Vue {
		userDataList: Array < any > = [];
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		searchText: string = '';
		loading: boolean = false;
		created() {
			this.searchData();
		}
		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}
		searchData() {
			this.loading = true;
			this.$request({
					url: '/bjba/yhgl/searchSbUser',
					method: 'get',
					params: {
						currentNo: this.currentNo,
						pageSize: this.pageSize,
						xm: `%${this.searchText}%`
					}
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.userDataList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
				});
		}

		unboundEquipment(userId: string, userName: string) {
			let that = this;
			that.$confirm(`确定要解除[${userName}]用户绑定的设备吗?`, '操作提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				that.$request({
						url: '/bjba/yhgl/unboundEquipment',
						method: 'post',
						params: {
							userId
						}
					})
					.then(response => {
						let data = response.data;
						if (data.code == 200) {
							that.$message.success(data.message)
							that.searchData();
						} else {
							that.$message.error(data.message)
						}
					})
					.catch(error => {
						console.log(error)
					});
			}).catch(() => {});
		}

		// 锁定,解除 用户
		lockUser(userId: string, userName: string, status: string) {
			let that = this;
			if (!status) return;
			let massage = '';

			if (status === '1') {
				massage = `确定要锁定[${userName}]用户吗 ?  锁定期间该用户将无法登录系统 !`;
			} else {
				massage = `确定要解除[${userName}]用户的锁定吗? 锁定解除后该用户可以正常访问系统 !`;
			}
			that.$confirm(massage, '操作提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				that.$request({
						url: '/bjba/yhgl/lockUser',
						method: 'post',
						params: {
							userId,
							status
						}
					})
					.then(response => {
						let data = response.data;
						if (data.code == 200) {
							that.$message.success("操作成功!")
							that.searchData();
						} else {
							that.$message.error(data.message)
						}
					})
					.catch(error => {
						console.log(error)
					});
			}).catch(() => {});
		}
	}
